/* eslint-disable array-callback-return, eqeqeq */

import {
  all,
  call,
  fork,
  put,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import request from "../util/request";
import dayjs from "dayjs";
import {
  fetch_patients as fetch_patient_action,
  fetch_patients_success,
  fetch_patients_failed,
  set_patient_info_null,
  fetch_patient_data_loading,
  fetch_patient_data as fetch_patient_data_action,
  fetch_patient_data_success,
  fetch_patient_data_failed,
  add_new_patient_success,
  add_new_patient_failed,
  update_patient_info_success,
  update_patient_info_failed,
  update_patient_details_success,
  update_patient_details_failed,
  update_recent_patient_count_success,
  update_recent_patient_count_failed,
  upload_patient_report_success,
  upload_patient_report_failed,
  add_patient_comment_success,
  add_patient_comment_failed,
  fetch_patient_comment_success,
  fetch_patient_comment_failed,
  fetch_patient_comment as fetch_patient_comment_action,
  update_patient_comment_success,
  update_patient_comment_failed,
  delete_patient_comment_success,
  delete_patient_comment_failed,
  fetch_disease_list_success,
  fetch_disease_list_failed,
  fetch_patient_disease as fetch_patient_disease_action,
  fetch_patient_disease_success,
  fetch_patient_disease_failed,
  fetch_checkup_dates as fetch_checkup_dates_action,
  fetch_checkup_dates_success,
  fetch_checkup_dates_failed,
  add_checkup_date_success,
  add_checkup_date_failed,
  checkup_mark_as_complete_success,
  checkup_mark_as_complete_failed,
  fetch_patients_summary_success,
  fetch_patients_summary_failed,
  generate_patient_id_success,
  generate_patient_id_failed,
  toggle_patient_status_success,
  toggle_patient_status_failed,
  fetch_patient_medication_symptoms_history_success,
  fetch_patient_medication_symptoms_history_failed,
  update_sample_patient_success,
  update_sample_patient_failed,
  fetch_patients_qna_response_success,
  fetch_patients_qna_response_failed,
  generate_report_success,
  generate_report_failed,
} from "actions/patients";
import { device_operation } from "actions/user";
import { fetch_nights_available } from "actions/kpi";

import {
  FETCH_PATIENTS,
  FETCH_PATIENT_DATA,
  ADD_NEW_PATIENT,
  UPDATE_PATIENT,
  UPDATE_PATIENT_DETAILS,
  UPLOAD_PATIENT_REPORT,
  UPDATE_RECENT_PATIENT_COUNT,
  SAVE_PATIENT_COMMENT,
  FETCH_PATIENT_COMMENT,
  UPDATE_PATIENT_COMMENT,
  DELETE_PATIENT_COMMENT,
  FETCH_DISEASE_LIST,
  FETCH_PATIENT_DISEASE,
  FETCH_CHECKUP_DATES,
  ADD_CHECKUP_DATE,
  CHECKUP_MARK_AS_COMPLETE,
  FETCH_PATIENTS_SUMMARY,
  GENERATE_PATIENT_ID,
  TOGGLE_PATIENT_STATUS,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY,
  UPDATE_SAMPLE_PATIENT,
  REFRESH_STATISTICS,
  FETCH_PATIENTS_QNA,
  GENERATE_AUTOMATED_REPORT,
  GENERATE_AUTOMATED_REPORT_DATA,
  GENERATE_AUTOMATED_REPORT_STATUS,
} from "constants/ActionTypes";

import { show_auth_message } from "actions/Auth";
import { delay } from "redux-saga";

const add_patient_details = async (payload) =>
  await request({
    path: "/physician/new-patient",
    method: "POST",
    body: JSON.stringify(payload),
  });

function* fetch_patients_saga(action) {
  try {
    let path = "/physician/patients";
    if (action.payload) {
      const user_id = action.payload.map((u) => u.user_id).join(",");
      path += `?user_id=${user_id}`;
    }

    const response = yield call(request, {
      path,
      method: "GET",
    });

    const { patients } = response.data;
    const patientList = [];
    patients.forEach((p) => {
      if (
        !p.phys_device_return_date ||
        p.phys_device_return_date
        // && moment.utc().format('YYYY-MM-DD') < moment.utc(p.phys_device_return_date).format('YYYY-MM-DD')
      ) {
        patientList.push(p);
      }
    });

    if (response.status === 200) {
      yield put(fetch_patients_success(patientList));
      if (!action.payload) {
        yield fetch_unseen_widget();
      }
    } else {
      yield put(fetch_patients_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_patient_qna_response_saga(params) {
  const { date, patient_id } = params.payload;
  try {
    const path = `/device/qna?date=${date}&patient_id=${patient_id}`;
    const response = yield call(request, {
      path,
      method: "GET",
    });
    if (response.status === 200 && response.code !== "response_unavailable") {
      const { response: qna_response } = response.data;
      yield put(fetch_patients_qna_response_success(qna_response));
    } else {
      yield put(fetch_patients_qna_response_failed());
    }
  } catch (error) {
    console.error(error);
    yield put(fetch_patients_qna_response_failed());
  }
}

function* fetch_unseen_widget() {
  try {
    let path = "/physician/patients/unseen-recordings";
    const response = yield call(request, {
      path,
      method: "GET",
    });
    const { patients } = response.data;
    if (response.status === 200) {
      yield put(fetch_patients_success({ widget: patients }));
    } else {
      yield put(fetch_patients_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_patient_data_saga({ payload }) {
  try {
    yield put(set_patient_info_null());
    yield put(fetch_patient_data_loading(true));
    const response = yield call(request, {
      path: "/patient/details?patient_id=" + payload.patient_id,
      method: "GET",
    });
    if (response.status === 200) {
      const { patient_info } = response.data;
      if (!window.location.pathname.includes("/edit")) {
        yield put(fetch_nights_available(patient_info));
      }
      yield put(fetch_patient_data_success(response.data));
      yield put(fetch_patient_data_loading("loaded"));
    } else {
      // TODO: uncomment redirect
      // window.location.replace("/app/Error404");
      yield put(fetch_patient_data_failed());
      yield put(fetch_patient_data_loading(false));
    }
  } catch (error) {
    console.error(error);
    yield put(fetch_patient_data_failed(error));
    yield put(fetch_patient_data_loading(false));
  }
}

function* add_new_patient_saga({ payload }) {
  try {
    const { diseaseIds, docter_id } = payload;

    const patient_details_payload = {
      patient_code: payload.patient_code,
      first_name: payload.first_name,
      last_name: payload.last_name,
      email_id: payload.email_id,
      gender: payload.gender,
      date_of_birth: payload.date_of_birth,
      at_risk: payload.at_risk,
      height: payload.height,
      weight: payload.weight,
      bmi: payload.bmi,
      vital_parameters: payload.vital_parameters,
      comment: payload.comment,
      diseases: payload.diseases,
      timezone: payload.country,
      address: payload.address,
      tags: payload.tags,
      window_start_time: payload.window_start_time,
      window_end_time: payload.window_end_time,
      device_allocation_date: null,
      device_deallocation_date: null,
      device_master_id: null,
      device_id: "",
    };
    const response = yield call(add_patient_details, patient_details_payload);
    const { data = {} } = response;

    if (response.status === 200) {
      yield put(
        fetch_patient_disease_action({
          patient_id: response.patientId,
          type: "update",
          disease_id: diseaseIds,
          docter_id: docter_id,
        })
      );

      if (payload.device_id && payload.device_id !== "") {
        yield put(
          device_operation({
            patient_id: response.patientId,
            device_id: payload.device_id,
            allocation_date: dayjs(payload.device_allocation_date).format(),
            deallocation_date: dayjs(payload.device_deallocation_date).format(),
            type: "deploy",
            window_start_time: payload.window_start_time,
            window_end_time: payload.window_end_time,
            country: payload.country,
          })
        );
      }

      yield put(add_new_patient_success(response.message));
    } else if (
      response.status === 500 &&
      response.code === "patient_id_exists"
    ) {
      yield put(add_new_patient_failed(response.code));
    } else {
      yield put(add_new_patient_failed(data.user_id));
    }
  } catch (error) {
    console.error(error);
    yield put(add_new_patient_failed(error));
  }
}

function* update_patient_info_saga({ payload }) {
  try {
    const {
      allocate_device,
      change_allocation_times,
      force_extend,
      user_id,
      device_id,
      device_allocation_date,
      device_deallocation_date,
      device_user_map_id,
      cancel_device,
      country,
      window_start_time,
      window_end_time,
    } = payload;

    let response;

    let operation = "";
    if (change_allocation_times) {
      operation = "extend";
      if (force_extend) {
        operation = "force-extend";
      }
    } else if (allocate_device && !force_extend) {
      operation = "deploy";
    } else if (allocate_device && force_extend) {
      operation = "force-deploy";
    }

    if (cancel_device) {
      operation = "cancel";
    }

    if (country && !cancel_device && !force_extend && !change_allocation_times) {
      operation = "force-deploy";
    }

    if (operation) {
      yield put(
        device_operation({
          patient_id: user_id,
          device_id: device_id,
          device_user_map_id: device_user_map_id,
          allocation_date: device_allocation_date,
          deallocation_date: device_deallocation_date,
          type: operation,
          country: country,
          window_start_time,
          window_end_time,
          get_patients_details: true,
        })
      );
    } else {
      response = yield call(request, {
        path: "/physician/update-patient-info",
        method: "POST",
        body: JSON.stringify({
          ...payload,
          change_allocation_times: false,
          allocate_device: false,
        }),
      });
    }
    if (
      response &&
      response.status === 200 &&
      response.code === "patient_info_updated_succesfully"
    ) {
      yield put(fetch_patient_data_action(payload.user_id));
      yield put(update_patient_info_success(response.message));
    } else {
      yield put(update_patient_info_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* update_patient_details_saga({ payload }) {
  try {
    const { user_id, fields_data, reload_patient_list } = payload;

    const response = yield call(request, {
      path: "/physician/update-patient-details/id=" + user_id,
      method: "POST",
      body: JSON.stringify({
        ...fields_data,
      }),
    });

    if (response && response.status === 200) {
      yield put(update_patient_details_success(response.message));
      if (reload_patient_list && reload_patient_list === 1) {
        yield put(fetch_patient_action());
      }
    } else {
      yield put(update_patient_details_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* upload_patient_report_saga({ payload }) {
  let formData = new FormData();
  try {
    const { finalBlob, finalFileName, selectedJiraKey } = payload;

    formData.append("blob", finalBlob);
    formData.append("fileName", finalFileName);

    const response = yield call(
      request,
      {
        path: `/patient/upload_report?jira_key=${selectedJiraKey}`,
        method: "POST",
        body: formData,
      },
      null,
      true
    );

    if (response && response.status === 200) {
      yield put(upload_patient_report_success(response.status));
    } else {
      yield put(upload_patient_report_failed(response));
    }
  } catch (error) {
    console.error(error);
  }
}

function* toggle_patient_status_saga({ payload }) {
  try {
    let response = yield call(request, {
      path: "/physician/update-patient-status",
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (response && response.status === 200) {
      yield put(toggle_patient_status_success(response.message));
      const { get_patients } = payload;
      if (get_patients === 1) {
        yield put(fetch_patient_action());
      }
    } else {
      yield put(toggle_patient_status_failed(response && response.error));
    }
  } catch (error) {
    console.error(error);
    yield put(toggle_patient_status_failed(error));
  }
}

function* update_recent_patient_count_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/update-recent-patient-count",
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (response.status === 200) {
      yield put(update_recent_patient_count_success(response.message));
    } else {
      yield put(update_recent_patient_count_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* save_patient_comment_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/add-comment",
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (response.status == 200) {
      yield put(add_patient_comment_success(response.message));
      yield put(show_auth_message("Comment added successfully"));
      yield put(
        fetch_patient_comment_action({ id: payload["payload"].user_id })
      );
    } else {
      yield put(add_patient_comment_failed(response.message));
      yield put(show_auth_message("Comment not added successfully"));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetch_patient_comment_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/get-comment",
      method: "POST",
      body: JSON.stringify(payload),
    });
    const { data = {} } = response;
    if (response.status == 200) {
      yield put(fetch_patient_comment_success(data));
    } else {
      yield put(fetch_patient_comment_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* update_patient_comment_saga(payload) {
  const { data } = payload;
  try {
    const response = yield call(request, {
      path: "/patient/update-comment",
      method: "POST",
      body: JSON.stringify(data),
    });

    if (response.status == 200) {
      yield put(update_patient_comment_success(response.data));
      yield put(fetch_patient_comment_action({ id: data.user_id }));
    } else {
      yield put(update_patient_comment_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* delete_patient_comment_saga(payload) {
  const { data } = payload;
  try {
    const response = yield call(request, {
      path: "/patient/delete-comment",
      method: "POST",
      body: JSON.stringify(data),
    });

    if (response.status == 200) {
      yield put(delete_patient_comment_success(response.data));
      yield put(fetch_patient_comment_action({ id: data.user_id }));
    } else {
      yield put(delete_patient_comment_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetch_patient_disease_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/disease-operation",
      method: "POST",
      body: JSON.stringify(payload.data),
    });
    if (response.status == 200 && response.data) {
      yield put(fetch_patient_disease_success(response.data));
    } else {
      yield put(fetch_patient_disease_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
export function* fetch_patient_disease() {
  yield takeLatest(FETCH_PATIENT_DISEASE, fetch_patient_disease_saga);
}
function* fetch_disease_list_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/get-disease-list",
      method: "POST",
      body: JSON.stringify(payload),
    });
    if (response.status == 200 && response.data) {
      yield put(fetch_disease_list_success(response.data));
    } else {
      yield put(fetch_disease_list_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* fetch_checkup_dates_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/get-checkup-list",
      method: "POST",
      body: JSON.stringify(payload.data),
    });
    if (response.status == 200 && response.data) {
      yield put(
        fetch_checkup_dates_success(
          response.data.filter((data) => data.checkup_date)
        )
      );
    } else {
      yield put(fetch_checkup_dates_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
export function* fetch_checkup_dates() {
  yield takeLatest(FETCH_CHECKUP_DATES, fetch_checkup_dates_saga);
}
function* add_checkup_date_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/add-checkup",
      method: "POST",
      body: JSON.stringify(payload.data),
    });
    if (response.status == 200) {
      yield put(add_checkup_date_success(response.data));
      const { patient_id, doctor_id } = payload.data;
      yield put(fetch_checkup_dates_action({ patient_id, doctor_id }));
    } else {
      yield put(add_checkup_date_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

export function* add_checkup_date() {
  yield takeLatest(ADD_CHECKUP_DATE, add_checkup_date_saga);
}
function* checkup_mark_as_complete_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/mark-as-complete",
      method: "POST",
      body: JSON.stringify(payload.data),
    });
    if (response.status == 200) {
      yield put(checkup_mark_as_complete_success(response.data));
      const { patient_id, doctor_id } = payload.data;
      yield put(fetch_checkup_dates_action({ patient_id, doctor_id }));
    } else {
      yield put(checkup_mark_as_complete_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_patients_summary_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/analytics/patient/all-kpi-summary",
      method: "POST",
      body: JSON.stringify(payload.data),
    });
    if (response.status == 200 && response.data) {
      yield put(fetch_patients_summary_success(response.data));
    } else {
      yield put(fetch_patients_summary_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

function* generate_patient_id_saga() {
  try {
    const response = yield call(request, {
      path: "/patient/generate-code",
      method: "GET",
    });

    if (response.status == 200 && response.code) {
      yield put(generate_patient_id_success(response.code));
    } else {
      yield put(generate_patient_id_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

let url = "https://sleepiz.io";
function* refresh_statistics_saga(payload) {
  const { device_id, recording_date } = payload.data;
  let rec_date = dayjs(recording_date).format("YYYY-MM-DD");
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbF9pZCI6ImRpcmVjdHRvcGF0aWVudEBzbGVlcGl6LmNvbSIsImlzU2Vjb25kYXJ5VXNlciI6dHJ1ZSwic2Vjb25kYXJ5X2VtYWlsIjoicm9oaXRAbWFpbGluYXRvci5jb20iLCJwYXNzd29yZCI6IjUzZTQyY2U2NDM3Y2NiMjUyMWI4YWU3YzQ5MmExZjY1IiwiaWF0IjoxNjgyNDM2OTY3fQ.CvzGRBs7omc-uk7EYPMbPy4iixE2Tl-LaGXLU5ufByM",
      },
      body: JSON.stringify({ device_id: device_id, date: rec_date }),
    };

    const response = yield fetch(
      `${url}/insomnia/process_kpis`,
      requestOptions
    ).then((response) => response.json());

    if (response) {
      yield fetch_patients_summary_saga(payload);
    }
  } catch (error) {
    console.error(error);
  }
}

function* generate_automated_report_data_saga(payload) {
  const { patient_code, language, version, dates } = payload.data;
  let range = dates
    .filter((d) => d.checked) // Filter out elements where checked is falsy
    .map((d) => d.numDate);
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbF9pZCI6ImRpcmVjdHRvcGF0aWVudEBzbGVlcGl6LmNvbSIsImlzU2Vjb25kYXJ5VXNlciI6dHJ1ZSwic2Vjb25kYXJ5X2VtYWlsIjoicm9oaXRAbWFpbGluYXRvci5jb20iLCJwYXNzd29yZCI6IjUzZTQyY2U2NDM3Y2NiMjUyMWI4YWU3YzQ5MmExZjY1IiwiaWF0IjoxNjgyNDM2OTY3fQ.CvzGRBs7omc-uk7EYPMbPy4iixE2Tl-LaGXLU5ufByM",
      },
      body: JSON.stringify({
        order_id: patient_code,
        language: language,
        version: version,
        recording_dates: range,
      }),
    };

    yield fetch(`${url}/insomnia/create_report_json_content`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {
        console.error(
          "There was a problem with the generate_data operation:",
          error
        );
      });
    yield delay(5000);

    while (true) {
      const status_response = yield call(
        generate_automated_report_status_saga,
        payload
      );

      if (status_response.status === 200) {
        const render_report = yield call(
          generate_automated_report_saga,
          payload
        );
        if (render_report) {
          yield put(generate_report_success(render_report));
        }
        break;
      } else if (
        status_response.status === 422 ||
        status_response.status === 500 ||
        status_response.status === 404
      ) {
        yield put(generate_report_failed("Generating Automated report failed"));
        break;
      }
      yield delay(5000);
    }
  } catch (error) {
    console.error(error);
  }
}

function* generate_automated_report_status_saga(payload) {
  const { patient_code, language, version, dates } = payload.data;
  let range = dates
    .filter((d) => d.checked) // Filter out elements where checked is falsy
    .map((d) => d.numDate);
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbF9pZCI6ImRpcmVjdHRvcGF0aWVudEBzbGVlcGl6LmNvbSIsImlzU2Vjb25kYXJ5VXNlciI6dHJ1ZSwic2Vjb25kYXJ5X2VtYWlsIjoicm9oaXRAbWFpbGluYXRvci5jb20iLCJwYXNzd29yZCI6IjUzZTQyY2U2NDM3Y2NiMjUyMWI4YWU3YzQ5MmExZjY1IiwiaWF0IjoxNjgyNDM2OTY3fQ.CvzGRBs7omc-uk7EYPMbPy4iixE2Tl-LaGXLU5ufByM",
      },
      body: JSON.stringify({
        order_id: patient_code,
        language: language,
        version: version,
        recording_dates: range,
      }),
    };

    const status_response = yield fetch(
      `${url}/insomnia/check_report_status`,
      requestOptions
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(
          "There was a problem with the check status operation:",
          error
        );
      });
    return status_response;

    // yield fetch_patients_summary_saga(payload);
  } catch (error) {
    console.error(error);
  }
}

function* generate_automated_report_saga(payload) {
  const { patient_code, language, version, dates } = payload.data;
  let range = dates
    .filter((d) => d.checked) // Filter out elements where checked is falsy
    .map((d) => d.numDate);
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbF9pZCI6ImRpcmVjdHRvcGF0aWVudEBzbGVlcGl6LmNvbSIsImlzU2Vjb25kYXJ5VXNlciI6dHJ1ZSwic2Vjb25kYXJ5X2VtYWlsIjoicm9oaXRAbWFpbGluYXRvci5jb20iLCJwYXNzd29yZCI6IjUzZTQyY2U2NDM3Y2NiMjUyMWI4YWU3YzQ5MmExZjY1IiwiaWF0IjoxNjgyNDM2OTY3fQ.CvzGRBs7omc-uk7EYPMbPy4iixE2Tl-LaGXLU5ufByM",
      },
      body: JSON.stringify({
        order_id: patient_code,
        language: language,
        version: version,
        recording_dates: range,
      }),
    };

    const report__render_response = yield fetch(
      `${url}/insomnia/render_report`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob(); // Read the response body as a Blob
      })
      .then((blob) => {
        if (blob.size === 0) {
          put(generate_report_failed("Empty response body"));
        }
        // Create a URL for the Blob object
        const pdfUrl = URL.createObjectURL(blob);

        // Now you can use pdfUrl to display the PDF in an <iframe> or <object>, or for other purposes
        return pdfUrl;
      })
      .catch((error) => {
        // Handle errors
        console.error("There was a problem with the render operation:", error);
      });

    return report__render_response;

    // yield fetch_patients_summary_saga(payload);
  } catch (error) {
    console.error(error);
  }
}

function* update_sample_patient_saga(payload) {
  try {
    const response = yield call(request, {
      path: "/patient/samplePatient",
      method: "POST",
      body: JSON.stringify(payload.data),
    });

    if (response.status == 200 && response.code) {
      yield put(update_sample_patient_success(response.code));
    } else {
      yield put(update_sample_patient_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_patient_medication_symptoms_history_saga(payload) {
  try {
    const response_medications = yield call(request, {
      path: `/patient/fetch-medications?patient_id=${
        payload.payload.patient_id
      }`,
      method: "GET",
    });
    const response_symptoms = yield call(request, {
      path: `/patient/fetch-symptoms?patient_id=${payload.payload.patient_id}`,
      method: "GET",
    });
    const response_diet_plan = yield call(request, {
      path: `/patient/fetch-diet-plan?patient_id=${payload.payload.patient_id}`,
      method: "GET",
    });

    let response = {};
    let error = {};
    if (!response_medications) {
      error.medications = "not found";
    } else if (response_medications.status === 200) {
      response.medications = response_medications.data;
    } else {
      error.medications = response_medications.message;
    }
    if (!response_symptoms) {
      error.symptoms = "not found";
    } else if (response_symptoms.status === 200) {
      response.symptoms = response_symptoms.data;
    } else {
      error.symptoms = response_symptoms.message;
    }
    if (!response_diet_plan) {
      error.diet_plan = "not found";
    } else if (response_diet_plan.status === 200) {
      response.diet_plan = response_diet_plan.data;
    } else {
      error.diet_plan = response_diet_plan.message;
    }

    if (
      (response_medications && response_medications.status === 200) ||
      (response_symptoms && response_symptoms.status === 200) ||
      (response_diet_plan && response_diet_plan.status === 200)
    ) {
      yield put(fetch_patient_medication_symptoms_history_success(response));
    } else {
      yield put(fetch_patient_medication_symptoms_history_failed(error));
    }
  } catch (error) {
    console.error(error);
  }
}

export function* generate_patient_id() {
  yield takeLatest(GENERATE_PATIENT_ID, generate_patient_id_saga);
}
export function* fetch_patients_summary() {
  yield takeEvery(FETCH_PATIENTS_SUMMARY, fetch_patients_summary_saga);
}
export function* checkup_mark_as_complete() {
  yield takeLatest(CHECKUP_MARK_AS_COMPLETE, checkup_mark_as_complete_saga);
}
export function* fetch_disease_list() {
  yield takeLatest(FETCH_DISEASE_LIST, fetch_disease_list_saga);
}
export function* fetch_patient_comment() {
  yield takeLatest(FETCH_PATIENT_COMMENT, fetch_patient_comment_saga);
}
export function* save_patient_comment() {
  yield takeLatest(SAVE_PATIENT_COMMENT, save_patient_comment_saga);
}
export function* update_patient_comment() {
  yield takeLatest(UPDATE_PATIENT_COMMENT, update_patient_comment_saga);
}
export function* delete_patient_comment() {
  yield takeLatest(DELETE_PATIENT_COMMENT, delete_patient_comment_saga);
}
export function* update_recent_patient_count() {
  yield takeLatest(
    UPDATE_RECENT_PATIENT_COUNT,
    update_recent_patient_count_saga
  );
}

export function* add_new_patient() {
  yield takeLatest(ADD_NEW_PATIENT, add_new_patient_saga);
}

export function* fetch_patients() {
  yield takeLatest(FETCH_PATIENTS, fetch_patients_saga);
}

export function* fetch_patient_data() {
  yield takeLatest(FETCH_PATIENT_DATA, fetch_patient_data_saga);
}

export function* fetch_patient_qna_response() {
  yield takeLatest(FETCH_PATIENTS_QNA, fetch_patient_qna_response_saga);
}

export function* update_patient_info() {
  yield takeLatest(UPDATE_PATIENT, update_patient_info_saga);
}

export function* update_patient_details() {
  yield takeLatest(UPDATE_PATIENT_DETAILS, update_patient_details_saga);
}

export function* upload_patient_report() {
  yield takeLatest(UPLOAD_PATIENT_REPORT, upload_patient_report_saga);
}

export function* toggle_patient_status() {
  yield takeLatest(TOGGLE_PATIENT_STATUS, toggle_patient_status_saga);
}
export function* fetch_patient_medication_symptoms_history() {
  yield takeLatest(
    FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY,
    fetch_patient_medication_symptoms_history_saga
  );
}
export function* update_sample_patient_data() {
  yield takeLatest(UPDATE_SAMPLE_PATIENT, update_sample_patient_saga);
}

export function* trigger_refresh_statistics() {
  yield takeEvery(REFRESH_STATISTICS, refresh_statistics_saga);
}

export function* generate_automated_report() {
  yield takeLatest(GENERATE_AUTOMATED_REPORT, generate_automated_report_saga);
}

export function* generate_automated_data_report() {
  yield takeLatest(
    GENERATE_AUTOMATED_REPORT_DATA,
    generate_automated_report_data_saga
  );
}

export function* generate_automated_report_status() {
  yield takeLatest(
    GENERATE_AUTOMATED_REPORT_STATUS,
    generate_automated_report_status_saga
  );
}

export default function* rootSaga() {
  yield all([
    fork(fetch_patients),
    fork(add_new_patient),
    fork(fetch_patient_data),
    fork(update_patient_info),
    fork(update_patient_details),
    fork(upload_patient_report),
    fork(update_recent_patient_count),
    fork(save_patient_comment),
    fork(fetch_patient_comment),
    fork(fetch_patient_qna_response),
    fork(update_patient_comment),
    fork(delete_patient_comment),
    fork(fetch_disease_list),
    fork(fetch_patient_disease),
    fork(fetch_checkup_dates),
    fork(add_checkup_date),
    fork(checkup_mark_as_complete),
    fork(fetch_patients_summary),
    fork(generate_patient_id),
    fork(toggle_patient_status),
    fork(fetch_patient_medication_symptoms_history),
    fork(update_sample_patient_data),
    fork(trigger_refresh_statistics),
    fork(generate_automated_report),
    fork(generate_automated_data_report),
    fork(generate_automated_report_status),
  ]);
}
